import TagManager from 'react-gtm-module';
import { extractUserRole, extractUserType, containsBackofficeRole } from './roles-module';
import { getUserService } from './user-module';
import { getAuthCookie } from './http-module';

TagManager.initialize('GTM-PWLD9T7');

export const insertDataLayerEvent = dataLayer => {
  TagManager.dataLayer({ dataLayer });
};

export const buildDataLayerPageView = pagePath => {
  return {
    dataLayer: {
      event: 'ga_pageview',
      pagePath,
    },
  };
};

export const insertDataLayerPageView = pagePath => {
  const data = {
    dataLayer: {
      event: 'ga_pageview',
      pagePath,
    },
  };
  TagManager.dataLayer(data);
};

export const pushDataLayerEvent = async (eventKey, additionalData = {}) => {
  if (eventKey) {
    dataLayer.push({ ...eventKey, ...additionalData });
  }
};

export const processAndPushDataLayerEvent = async (
  eventKey,
  requiredRoles = false,
  additionalData = {}
) => {
  if (requiredRoles) {
    const { data } = await getUserService(getAuthCookie());
    const roles = data.roles;

    if (containsBackofficeRole(roles)) return;  

    const userRol = extractUserRole(roles);
    const userType = extractUserType(roles);

    if (userRol && userType) {
      pushDataLayerEvent(eventKey, {
        user_rol: userRol,
        user_type: userType,
        ...additionalData
      });
    }
  } else {
    pushDataLayerEvent(eventKey, additionalData);
  }
};
